import { useContext, useEffect, useState } from "react";
import { filterData, getDataList, getDataObtenerUno } from "../../api/common";
import { useAuth } from "../../hooks/useAuth";
import { BarChar } from "./BarChart";
import { CardDashboard } from "./CardsDashboard";
import { CircularChart } from "./CircularChart";
import UserContext from "../../context/User/UserContext";
import { now } from "moment/moment";
import { ChartDate } from "./ChartDate";


export function Dashboard() {
  const { userData } = useAuth();
  const [data, setData] = useState({})
  const { setUserData } = useContext(UserContext);
  const {allOt, allEquipos, allClientes, OtOpenClose, clientesByZone} = data;

  const getDataDashBoard = async() => {
    const {data} = await getDataList('dashboard');
    
    /*const prueba = await filterData('dashboard',
    {
      fechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 6)),  // hace 6 meses
      fechaFin: new Date()  // fecha actual
    });*/
    
    setData(data);
    console.log(data);
  }

  useEffect( () => {
    getDataDashBoard();
  }, []);

    return(
      <>
      {userData.role.nombre!=='Cliente'?
        <div className="dashboard-container-main">
          <div className="dashboard-group">
            <CardDashboard value={allOt} description={'Total Ordenes'}/>
            <CardDashboard value={allClientes} description={'Total Clientes'}/>
            <CardDashboard value={allEquipos} description={'Total Equipos'}/>
          </div>

          <div className="dashboard-group">
            <CircularChart labels={['Abiertas', 'Cerradas', 'Programada', 'Solicitud', 'Revisión', 'Entrega', 'Facturar']} data={OtOpenClose} title={'Estado de Ordenes'}/>
            <BarChar title={'Clientes por zonas'} data={clientesByZone}/>
           {/* <BarChar />*/}
          </div>
          <ChartDate/>
        </div>:
        <div>
          <h6>No tienes permiso</h6>
            <i class="bi bi-slash-circle"></i>
        </div>
        }
        </>
    )


}